export const PAT_REGISTRATION_NUMBER = 'FA000005';
export const PAT_FACILITATOR_CORPORATE_NAME = 'VR BENEFICIOS E SERVICOS DE PROCESSAMENTO S.A';
export const PAT_FACILITATOR_CNPJ = '02.535.864/0001-33';
